import { styled } from '@mui/material/styles';
import { Button as BaseButton } from 'components/buttons';
import Container from '@mui/material/Container';

export const Paper = styled('div')(({ theme }) => ({
  margin: theme.spacing(3, 0),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '50%'
}));

export const Form = styled('form')(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(1)
}));

export const Typo = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  width: '100%',
  textTransform: 'uppercase'
}));

export const FormFooterContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: theme.spacing(2),
  width: '100%'
}));

export const NavLinkActive = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
  cursor: 'pointer',
  display: 'block',
  width: '100%',
  marginBottom: '16px',
  paddingBottom: '16px',
  borderBottom: '1px solid #ccc'
}));

export const NavLinkInactive = styled('span')(() => ({
  color: '#C8C8C8',
  cursor: 'pointer'
}));

export const Button = styled(BaseButton)(({ disabledColor }) => ({
  maxWidth: '230px',
  width: '167px',
  '&:disabled, &[disabled]': {
    background: disabledColor || '#F5F5F5',
    color: disabledColor ? 'white' : '#CCCCCC',
    '&:hover': {
      background: disabledColor || '#F5F5F5',
      color: disabledColor ? 'white' : '#CCCCCC'
    }
  }
}));

export const UploadButton = styled(BaseButton)(() => ({
  width: '100%'
}));

export const FooterActions = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  margin: theme.spacing(-1),
  padding: `${theme.spacing(4)} 0`,
  [`& ${Button}`]: {
    margin: theme.spacing(1),
    '@media (max-width: 400px)': {
      flexGrow: 1
    }
  }
}));

export const FormFooter = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center'
}));

export const AttachmentContainer = styled('div')(() => ({
  position: 'relative'
}));

export const FileUploadComponent = styled('input')(() => ({
  position: 'absolute',
  top: '0px',
  left: '0px',
  maxWidth: '100%',
  width: '100%',
  height: '55px',
  opacity: 0
}));

export const Section = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '0px',
  bottom: '0px',
  background: theme.color.background.section,
  maxWidth: '100%',
  width: '930px',
  overflow: 'auto'
}));

export const Footer = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row-reverse',
  paddingBottom: '20px',
  'button:last-child': {
    marginRight: '20px'
  }
}));

export const MuiContainer = styled(Container)(() => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center'
}));

export const LinkButton = styled('a')(({ theme }) => ({
  background: 'transparent',
  color: theme.color.primary.main,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  margin: '5px',
  textDecoration: 'none',
  padding: '3px 4px',
  lineHeight: '1.875em',
  fontWeight: 700,
  fontSize: '14px',
  textTransform: 'uppercase',
  width: '100px',
  border: `1px solid ${theme.color.primary.main}`
}));

export const FlexContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  alignItems: 'center'
}));

export const Text = styled('p')(() => ({}));

export const Image = styled('img')(({ mt, mb }) => ({
  width: '100%',
  objectFit: 'cover',
  ...(mt && { marginTop: `${mt}px` }),
  ...(mb && { marginBottom: `${mb}px` })
}));

export const VideoContainer = styled('div')(() => ({
  width: '100%',
  '.react-player': {
    height: '500px !important'
  },
  '@media (max-width: 925px)': {
    '.react-player': {
      height: 'auto !important'
    },
    iframe: {
      height: 'calc(100vw * 0.56) !important'
    }
  }
}));
